import { AxiosResponse } from "axios";

import { ENDPOINTS } from "./endpoints";
import HttpClient from "./HttpClient";

import { isSandboxAvailableRes } from "types/responses";

export const resetSandbox = async (): Promise<AxiosResponse> => {
  return await HttpClient.post(ENDPOINTS.sandbox.reset);
};

export const deleteSandbox = async (): Promise<AxiosResponse> => {
  return await HttpClient.post(ENDPOINTS.sandbox.delete);
};

export const getIsSandboxAvailable = async (): Promise<isSandboxAvailableRes> => {
  const res = await HttpClient.get(ENDPOINTS.sandbox.isSandboxAvailable);

  return res.data;
};
